export class Client {

  constructor(
    public hash: string,
    public code: string,
    public name: string,
    public businessName: string
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/client.ts